import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getInvoices as getInvoicesApi,
  addNewInvoice as addNewInvoiceApi,
  updateInvoice as updateInvoiceApi,
  deleteInvoice as deleteInvoiceApi,
  getInvoiceByNumber as getInvoiceByNumberApi,
} from "../../helpers/realbackend_helper";

export const getInvoices = createAsyncThunk("invoice/getInvoices", async () => {
  try {
    const response = await getInvoicesApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getInvoiceByNumber = createAsyncThunk(
  "invoice/getInvoiceByNumber",
  async (invoice) => {
    try {
      const response = await getInvoiceByNumberApi(invoice);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewInvoice = createAsyncThunk(
  "invoice/addNewInvoice",
  async (invoice) => {
    try {
      const response = addNewInvoiceApi(invoice);
      toast.success("Нэхэмжлэхийг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэхийг бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateInvoice = createAsyncThunk(
  "invoice/updateInvoice",
  async (invoice) => {
    try {
      const response = updateInvoiceApi(invoice);
      toast.success("Нэхэмжлэхийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэхийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteInvoice = createAsyncThunk(
  "invoice/deleteInvoice",
  async (id, { rejectWithValue }) => {
    try {
      await deleteInvoiceApi(id);

      toast.success("Нэхэмжлэхийг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Нэхэмжлэхийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
